import {
  Box,
  Button,
  Grid as ChakraGrid,
  Hide,
  HStack,
  Show,
} from '@chakra-ui/react';
import { Grid, ReviewStars } from '@time-line/components/common';
import * as routes from 'lib/constants/routes';
import NextLink from 'next/link';
import type { ReviewsCarousel as ReviewsCarouselProps } from 'types/cms/blocks';

import { ReviewsCarouselRich } from './ReviewsCarouselRich';
import { ReviewsMarquee } from './ReviewsMarquee';
import { useReviewsCarouselStats } from './useReviewsCarouselStats';

export function ReviewsCarousel(props: ReviewsCarouselProps) {
  const { showOverview, showRecommendationScore, reviews, backgroundImage } =
    props;
  const { stats } = useReviewsCarouselStats(reviews);

  if (backgroundImage) {
    return <ReviewsCarouselRich {...props} />;
  }

  return (
    <Grid className="section--reviews-overview-carousel" my="sm">
      <Grid.Inner>
        <Box gridColumn="span 12">
          <ChakraGrid
            display={{ base: 'block', md: 'grid' }}
            templateColumns="auto 1fr"
            alignItems="center"
            gap="m"
          >
            {stats?.ratingAverage != null && showOverview && (
              <HStack
                className="reviews-overview"
                wrap="wrap"
                spacing="4xs"
                justifyContent="center"
                alignItems="center"
              >
                <ReviewStars score={stats.ratingAverage} />
                <Button variant="link" as={NextLink} href={routes.REVIEWS}>
                  {stats.ratingAverage.toFixed(1)} from {stats.ratingCount}{' '}
                  reviews
                  {showRecommendationScore &&
                  stats.recommendedPercentage != null
                    ? ` · ${Math.round(stats.recommendedPercentage)}% recommend`
                    : ''}
                </Button>
              </HStack>
            )}
            <Hide below="md">
              <ReviewsMarquee reviews={reviews} hasFade />
            </Hide>
          </ChakraGrid>
        </Box>
      </Grid.Inner>
      <Show below="md">
        <Grid.Inner gridColumn="full">
          <Box gridColumn="span 12" mt="sm">
            <ReviewsMarquee reviews={reviews} />
          </Box>
        </Grid.Inner>
      </Show>
    </Grid>
  );
}
